import { Events } from 'src/constants/webSocketConsts/events';
import {
  handleDeletedCompanies,
  handleInsertedCompanies,
  handleModifiedCompanies,
} from 'src/store/clients/actions';
import { ensureUnreachable } from 'src/utils/common_utils';

const CompanyHandler = (event: Events, items: Array<any>) => {
  switch (event) {
    case Events.Insert:
      return handleInsertedCompanies(items);
    case Events.Modify:
      // Mark as WS event so the reducer doesn't set updatedClient
      return handleModifiedCompanies(items, true);
    case Events.Remove:
      return handleDeletedCompanies(items);
    case Events.DomainVerified:
    case Events.Refresh:
      return null;
    default:
      return ensureUnreachable(event);
  }
};

export default CompanyHandler;
